
import VueI18n from 'vue-i18n';
import { Component, Vue } from 'vue-property-decorator';
import { backendTranslationNamespace } from './i18n';

@Component({})
class BeTranslationMixin extends Vue {
  public $tbe(translationKey: string): VueI18n.TranslateResult {
    return this.$t(`${backendTranslationNamespace}.${translationKey}`);
  }
}

Vue.mixin(BeTranslationMixin);